<ng-template #modificarAvatar let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px; padding: 1rem 1rem 0.5rem 1rem;">
    <h5 class="modal-title">Modifica tu avatar</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <!-- <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" *ngIf="!imageChangedEvent"
      [uploader]="uploader" class="py-5 mb-3 text-center font-medium-5 text-uppercase grey my-drop-zone" (change)="fileChangeEvent($event)">
      Arrasta la imagen aqui
    </div> -->

    <div style="text-align: center;" *ngIf="!imageChangedEvent">
      <label class="font-medium-2 text-uppercase" style="font-size: 10pt;">Arrasta la imagen aqui</label>
    </div>

    <div class="file-container" *ngIf="!imageChangedEvent" >
        <input type="file" class="file" (change)="getFile($event)" style="width:100%"/>              
    </div>
    
    <br *ngIf="!imageChangedEvent">

    <div style="text-align: center;" *ngIf="!imageChangedEvent">
      <label class="font-medium-2 text-uppercase">o Selecciona tu archivo</label>
    </div>

    <div class="row" *ngIf="!imageChangedEvent">                             
      <div class="custom-file mx-auto d-block col-md-8">
        <input type="file" class="custom-file-input" id="inputGroupFile01" (change)="fileChangeEvent($event)" accept="image/png, image/gif, image/jpeg">
        <label class="custom-file-label" for="inputGroupFile01">Seleccion tu archivo</label>
      </div>
    </div>

    <div class="row" *ngIf="imageChangedEvent" style="text-align: center; margin-top: -15px">
      <div class="col-md-12" style="margin-top: 10px;">
        <button type="button" class="btn btn-sm btn-primary btn-raised" (click)="rotateLeft()" style="margin-left: 5px; width: 160px;">Gira a la izquierda</button>
        <button type="button" class="btn btn-sm btn-primary btn-raised" (click)="rotateRight()" style="margin-left: 5px; width: 160px;">Gira a la derecha</button>
        <button type="button" class="btn btn-sm btn-primary btn-raised" (click)="flipHorizontal()" style="margin-left: 5px; width: 160px;">Gira en horizontal</button>
        <button type="button" class="btn btn-sm btn-primary btn-raised" (click)="flipVertical()" style="margin-left: 5px; width: 160px;">Gira en vertical</button>
        <button type="button" class="btn btn-sm btn-warning btn-raised" (click)="cancelCropping()" style="margin-left: 5px; width: 180px;">Cancelar Imagen 
          <i class="ft-x position-right"></i>
        </button>    
      </div>
    </div>

    <div class="row" *ngIf="imageChangedEvent" style="text-align: center;">
      <div class="col-md-6">
        <div class="form-group">
          <table>
            <tr>
              <td>
                <label class="text-uppercase" style="font-size: 10pt;">Rotar</label>
              </td>
              <td>
                <input type="number" class="form-control" min="0" max="360" maxlength="3" style="margin-left: 5px; width: 70px; font-size: 10pt;"
                    [(ngModel)]="rotation" [ngModelOptions]="{standalone: true}" (ngModelChange)="revisarRotation()">
              </td>
              <td>
                <nouislider [min]="0" [max]="360" [step]="1" [(ngModel)]="rotation" (ngModelChange)="updateRotation()" style="width: 300px; margin-top: 50px; margin-left: 5px;">
                </nouislider>
              </td>              
            </tr>
          </table>          
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <table>
            <tr>
              <td>
                <label class="text-uppercase" style="font-size: 10pt;">Zoom</label>
              </td>
              <td>
                <input type="number" class="form-control" min="-10" max="10" maxlength="2" style="margin-left: 5px; width: 70px; font-size: 10pt;"
                    [(ngModel)]="scale" [ngModelOptions]="{standalone: true}" (ngModelChange)="revisarZoom()">
              </td>           
              <td>
                <nouislider [min]="-10" [max]="10" [step]="0.1" [(ngModel)]="scale" (ngModelChange)="zoomChange()" style="width: 300px; margin-top: 50px; margin-left: 5px;">
                </nouislider>
              </td>              
            </tr>
          </table>          
        </div>
      </div>
    </div>

    <!-- <div class="row" *ngIf="imageChangedEvent" style="text-align: center;">
      <input [(ngModel)]="rotation" placeholder="Rotation" type="number" (keyup)="updateRotation()" *ngIf="imageChangedEvent"/> <button (click)="zoomOut()" *ngIf="imageChangedEvent">Zoom -</button> <button (click)="zoomIn()" *ngIf="imageChangedEvent">Zoom +</button>
      <button type="button" *ngIf="imageChangedEvent" 
          class="btn mr-1 btn-raised btn-warning col-md-3 mx-auto" (click)="cancelCropping()">Cancelar Imagen 
          <i class="ft-x position-right"></i>
      </button>
    </div> -->

    <div class="row">                               
      <div class="col-md-6" style="margin-top: 10px;">
        <!-- <image-cropper [imageChangedEvent]="imageChangedEvent" 
                        [maintainAspectRatio]="true" 
                        [aspectRatio]="4 / 3"
                        [resizeToWidth]="512"
                        [cropperMinWidth]="128"
                        [onlyScaleDown]="true"
                        roundCropper = true
                        format="png" 
                        (imageCropped)="imageCropped($event)" 
                        (imageLoaded)="imageLoaded()"
                        (cropperReady)="cropperReady()" 
                        (loadImageFailed)="loadImageFailed()" 
                        class="float-left mr-4 img-fluid col-md-3"
                        [style.display]="showCropper ? null : 'none'">
        </image-cropper> -->
        <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [containWithinAspectRatio]="false"
            [resizeToWidth]="256"
            [cropperMinWidth]="128"
            [onlyScaleDown]="true"
            [roundCropper]="true"
            [canvasRotation]="canvasRotation"
            [transform]="transform"
            [alignImage]="'left'"
            [style.display]="showCropper ? null : 'none'"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"            
        >
        </image-cropper>
      </div>
      <br>
      <div class="col-md-6" style="margin-top: 10px; text-align: center;" *ngIf="showCropper">
        <span class="result">
          <img [src]="croppedImage" style="width: 360px; border-radius: 100%;"/>           
        </span>
      </div>
      
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm btn-raised" style="font-size: 10pt;" (click)="guardarImagen()">Guardar</button>
    <button type="button" class="btn btn-warning btn-sm btn-raised" style="font-size: 10pt;" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<ng-template #cambiarContrasenaModal let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px; padding: 1rem 1rem 0.5rem 1rem;">
    <h5 class="modal-title">Cambiar contraseña</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">    

    <div class="d-flex col-md-5 mx-auto">    
      <div class="align-self-center">

        <h6 class="card-title" id="basic-layout-form">Cambio contraseña</h6>  

        <div class="form-group" style="margin-top: -10px;">
          <input type="password" class="form-control mb-2" name="password" maxlength="12"
              [ngClass]="{ 'is-invalid': (apretoGuardarContrasena && errorContrasenaActual), 
              'is-valid': (apretoGuardarContrasena && !errorContrasenaActual) }"
              [(ngModel)]="contrasenaActual"
              placeholder="Contraseña Actual" 
              (blur)="confirmarContrasena()">
    
              <div *ngIf="(apretoGuardarContrasena && errorContrasenaActual)" style="font-size: 10pt; margin-top: -10px !important"
                  class="help-block mt-1 text-danger"> 
                  <i class="fas fa-exclamation-circle align-middle"></i> 
                  Debes escribir la contraseña actual.
              </div> 
        </div>
    
        <div class="form-group" style="margin-top: -5px;">
          <input type="password" class="form-control mb-2" name="passwordnuevo" maxlength="12"
          [ngClass]="{ 'is-invalid': (apretoGuardarContrasena && (errorContrasenaNueva || !contrasenaCoincide)), 
          'is-valid': (apretoGuardarContrasena && !errorContrasenaNueva && contrasenaCoincide) }"
          [(ngModel)]="contrasenaNueva"
              placeholder="Contraseña Nueva" 
              (blur)="confirmarContrasena()">
    
              <div *ngIf="(apretoGuardarContrasena && errorContrasenaNueva)" style="font-size: 10pt; margin-top: -10px !important"
                  class="help-block mt-1 text-danger"> 
                  <i class="fas fa-exclamation-circle align-middle"></i> 
                  Debes escribir la contraseña nueva.
              </div>
    
              <div *ngIf="(apretoGuardarContrasena && !contrasenaCoincide)" style="font-size: 10pt; margin-top: -10px !important"
                  class="help-block mt-1 text-danger"> 
                  <i class="fas fa-exclamation-circle align-middle"></i> 
                  La contraseña no coincide con la confirmación
              </div> 
        </div>
    
        <div class="form-group" style="margin-top: -5px;">
          <input type="password" class="form-control mb-2" name="confirmacionpassword" maxlength="12"
          [(ngModel)]="contrasenaNuevaConfirmar"
          [ngClass]="{ 'is-invalid': (apretoGuardarContrasena && (errorContrasenaNuevaCoincidencia || !contrasenaCoincide)), 
          'is-valid': (apretoGuardarContrasena && !errorContrasenaNuevaCoincidencia && contrasenaCoincide) }"
              placeholder="Confirmacion contraseña" 
              (blur)="confirmarContrasena()">
    
          <div *ngIf="(apretoGuardarContrasena && errorContrasenaNuevaCoincidencia)" style="font-size: 10pt; margin-top: -10px !important"
              class="help-block mt-1 text-danger"> 
              <i class="fas fa-exclamation-circle align-middle"></i> 
              Debes escribir la confirmacion de la contraseña nueva.
          </div>     
    
          <div *ngIf="(apretoGuardarContrasena && !contrasenaCoincide)" style="font-size: 10pt; margin-top: -10px !important"
              class="help-block mt-1 text-danger"> 
              <i class="fas fa-exclamation-circle align-middle"></i> 
              La contraseña no coincide con la confirmación
          </div> 
        </div>

      </div>
    </div>  

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-primary btn-raised" (click)="cambiarContrasena()">Guardar</button>
    <button type="button" class="btn btn-sm btn-secondary btn-raised" (click)="cerrarModalUsuario()">Close</button>
  </div>
</ng-template>

<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <a href="javascript:;">
            <img [src]="authService.usuarioConectado.Usuario.Urlimagen" alt="user view avatar"
              class="users-avatar-shadow rounded" height="64" width="64">
          </a>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{authService.usuarioConectado.Usuario.NombreCompleto}}</span>   
              <button type="button" class="btn btn-sm btn-primary" (click)="editarAvatar(modificarAvatar)">Cambiar avatar</button>           
            </h4>
            <span class="mr-1">Correo:</span>
            <span class="users-view-id">{{authService.usuarioConectado.Usuario.email}}</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <!-- <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"><i class="ft-mail"></i></a>
        <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2 px-3 py-1">Profile</a> -->        
        <a (click)="editarInformacion(cambiarContrasenaModal)" class="btn btn-sm btn-primary px-3 py-1">Cambiar Password</a>
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-4">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Empresa:</td>
                        <td>{{authService.usuarioConectado.Usuario.NombreEmpresa}}</td>
                      </tr>
                      <tr>
                        <td>Registrado:</td>
                        <td>{{authService.usuarioConectado.Usuario.FechaRegistro | date: 'yyyy/MM/dd'}}</td>
                      </tr>
                      <tr>
                        <td>Ultima Actividad:</td>
                        <td class="users-view-latest-activity">{{currentDate | date: 'yyyy/MM/dd'}}</td>
                      </tr>
                      <tr>
                        <td>Verificado:</td>
                        <td class="users-view-verified">Sí</td>
                      </tr>
                      <tr>
                        <td>Perfil:</td>
                        <td class="users-view-role">{{authService.usuarioConectado.Perfil.Nombre}}</td>
                      </tr>
                      <tr>
                        <td>Status:</td>
                        <td><span class="badge bg-light-success users-view-status">Active</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-12 col-xl-8 users-module">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th>Module Permission</th>
                          <th>Read</th>
                          <th>Write</th>
                          <th>Create</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Users</td>
                          <td>Yes</td>
                          <td>No</td>
                          <td>No</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>Articles</td>
                          <td>No</td>
                          <td>Yes</td>
                          <td>No</td>
                          <td>Yes</td>
                        </tr>
                        <tr>
                          <td>Staff</td>
                          <td>Yes</td>
                          <td>Yes</td>
                          <td>No</td>
                          <td>No</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Card data ends -->
      </div>
      <div class="col-12">
        <!-- User detail starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row bg-primary bg-lighten-4 rounded mb-3 mx-1 text-center text-lg-left">
                <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                  <h6 class="primary align-self-center mb-0 mx-1">Posts:</h6>
                  <span class="font-large-1 primary">125</span>
                </div>
                <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                  <h6 class="primary align-self-center mb-0 mx-1">Followers:</h6>
                  <span class="font-large-1 primary">534</span>
                </div>
                <div class="col-12 col-sm-4 p-3 d-flex align-itms-center">
                  <h6 class="primary align-self-center mb-0 mx-1">Following:</h6>
                  <span class="font-large-1 primary">256</span>
                </div>
              </div>
  
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Username:</td>
                        <td class="users-view-username">dean3004</td>
                      </tr>
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-name">Dean Stanley</td>
                      </tr>
                      <tr>
                        <td>E-mail:</td>
                        <td>deanstanley@gmail.com</td>
                      </tr>
                      <tr>
                        <td>Company:</td>
                        <td>XYZ Corp. Ltd.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <h5 class="mb-2 text-bold-500"><i class="ft-link mr-2"></i>Social Links</h5>
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Twitter:</td>
                        <td><a href="javascript:;">https://www.twitter.com/</a></td>
                      </tr>
                      <tr>
                        <td>Facebook:</td>
                        <td><a href="javascript:;">https://www.facebook.com/</a></td>
                      </tr>
                      <tr>
                        <td>Instagram:</td>
                        <td><a href="javascript:;">https://www.instagram.com/</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i> Personal Info</h5>
                <div class="table-responsive">
                  <table class="table table-borderless m-0">
                    <tbody>
                      <tr>
                        <td>Birthday:</td>
                        <td>1990/04/03</td>
                      </tr>
                      <tr>
                        <td>Country:</td>
                        <td>USA</td>
                      </tr>
                      <tr>
                        <td>Languages:</td>
                        <td>English</td>
                      </tr>
                      <tr>
                        <td>Contact:</td>
                        <td>+(305) 254 24668</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- User detail ends -->
      </div>
    </div>
  </section>
  